/* ============================================
   CONSTANTS — Enums, Options & Labels
   ============================================
   Central source of truth for all form options,
   dropdown values, and display labels.
   ============================================ */

// ---- Qualifikationen ----
export const QUALIFIKATIONEN = [
  { value: 'pflegefachkraft', label: 'Pflegefachkraft', icon: '🏥' },
  { value: 'pflegehilfskraft', label: 'Pflegehilfskraft', icon: '🤝' },
  { value: 'mfa', label: 'MFA', icon: '💉' },
  { value: 'altenpfleger', label: 'Altenpfleger/in', icon: '👴' },
  { value: 'guk', label: 'Gesundheits- und Krankenpfleger/in', icon: '⚕️' },
  { value: 'sonstiges', label: 'Sonstiges', icon: '📋' },
] as const

// ---- Arbeitsbereiche / Einsatzbereiche ----
export const ARBEITSBEREICHE = [
  { value: 'stationaer', label: 'Stationäre Pflege', icon: '🏠' },
  { value: 'ambulant', label: 'Ambulante Pflege', icon: '🚗' },
  { value: 'klinik', label: 'Klinik (Allgemein)', icon: '🏥' },
  { value: 'intensivpflege', label: 'Intensivpflege', icon: '💓' },
  { value: 'op_anaesthesie', label: 'OP / Anästhesie', icon: '🩻' },
  { value: 'notaufnahme', label: 'Notaufnahme', icon: '🚨' },
  { value: 'geriatrie', label: 'Geriatrie', icon: '👴' },
  { value: 'paediatrie', label: 'Pädiatrie (Kinder)', icon: '🧒' },
  { value: 'psychiatrie', label: 'Psychiatrie', icon: '🧠' },
  { value: 'palliativ', label: 'Palliativ / Hospiz', icon: '🕊️' },
  { value: 'reha', label: 'Reha-Pflege', icon: '🦽' },
  { value: 'onkologie', label: 'Onkologie', icon: '🎗️' },
  { value: 'tagespflege', label: 'Tagespflege', icon: '☀️' },
  { value: 'betreutes_wohnen', label: 'Betreutes Wohnen', icon: '🏡' },
  { value: 'sonstiges', label: 'Sonstiges', icon: '📋' },
] as const

// ---- Arbeitsmodelle ----
export const ARBEITSMODELLE = [
  { value: 'vollzeit', label: 'Vollzeit', icon: '⏰' },
  { value: 'teilzeit', label: 'Teilzeit', icon: '🕐' },
  { value: 'minijob', label: 'Minijob', icon: '💶' },
] as const

export const AKTUELLE_ARBEITSMODELLE = [
  { value: 'vollzeit', label: 'Vollzeit' },
  { value: 'teilzeit', label: 'Teilzeit' },
  { value: 'minijob', label: 'Minijob' },
  { value: 'zeitarbeit', label: 'Zeitarbeit' },
  { value: 'nicht_taetig', label: 'Nicht tätig' },
] as const

// ---- Schichtwünsche ----
export const SCHICHTWUENSCHE = [
  { value: 'frueh', label: 'Frühdienst', icon: '☀️' },
  { value: 'spaet', label: 'Spätdienst', icon: '🌅' },
  { value: 'nacht', label: 'Nachtdienst', icon: '🌙' },
  { value: 'nur_tagdienste', label: 'Nur Tagdienste', icon: '🌤️' },
  { value: 'keine_nachtdienste', label: 'Keine Nachtdienste', icon: '🚫' },
] as const

// ---- Wechselgründe (Pain Points) ----
export const WECHSELGRUENDE = [
  { value: 'einspringdienste', label: 'Zu viele Einspringdienste', icon: '📞' },
  { value: 'dienstplan', label: 'Schlechter Dienstplan', icon: '📅' },
  { value: 'gehalt', label: 'Zu wenig Gehalt', icon: '💰' },
  { value: 'fuehrung', label: 'Schlechte Führung', icon: '👔' },
  { value: 'teamprobleme', label: 'Teamprobleme', icon: '👥' },
  { value: 'ueberlastung', label: 'Überlastung', icon: '😰' },
  { value: 'zeit_patienten', label: 'Zu wenig Zeit für Patienten', icon: '⏳' },
  { value: 'wertschaetzung', label: 'Fehlende Wertschätzung', icon: '💔' },
  { value: 'anderer_bereich', label: 'Wunsch nach anderem Bereich', icon: '🔄' },
  { value: 'umzug', label: 'Umzug', icon: '📦' },
  { value: 'wiedereinstieg', label: 'Wiedereinstieg', icon: '🔙' },
  { value: 'koerperliche_belastung', label: 'Körperliche Belastung zu hoch', icon: '💪' },
  { value: 'sonstiges', label: 'Sonstiges', icon: '✏️' },
] as const

// ---- Prioritäten ----
export const PRIORITAETEN = [
  { value: 'gehalt', label: 'Gehalt', icon: '💰' },
  { value: 'arbeitsweg', label: 'Arbeitsweg', icon: '🚗' },
  { value: 'dienstplansicherheit', label: 'Dienstplansicherheit', icon: '📅' },
  { value: 'team', label: 'Team', icon: '👥' },
  { value: 'fuehrung', label: 'Führung', icon: '👔' },
  { value: 'arbeitsatmosphaere', label: 'Arbeitsatmosphäre', icon: '🌟' },
  { value: 'weniger_stress', label: 'Weniger Stress', icon: '🧘' },
  { value: 'feste_strukturen', label: 'Feste Strukturen', icon: '🏛️' },
  { value: 'entwicklung', label: 'Entwicklungsmöglichkeiten', icon: '📈' },
  { value: 'patientengruppe', label: 'Bestimmte Patientengruppe', icon: '🩺' },
  { value: 'familienfreundlich', label: 'Familienfreundliche Arbeitszeiten', icon: '👨‍👩‍👧' },
] as const

// ---- Bundesländer ----
export const BUNDESLAENDER = [
  { value: 'BW', label: 'Baden-Württemberg' },
  { value: 'BY', label: 'Bayern' },
  { value: 'BE', label: 'Berlin' },
  { value: 'BB', label: 'Brandenburg' },
  { value: 'HB', label: 'Bremen' },
  { value: 'HH', label: 'Hamburg' },
  { value: 'HE', label: 'Hessen' },
  { value: 'MV', label: 'Mecklenburg-Vorpommern' },
  { value: 'NI', label: 'Niedersachsen' },
  { value: 'NW', label: 'Nordrhein-Westfalen' },
  { value: 'RP', label: 'Rheinland-Pfalz' },
  { value: 'SL', label: 'Saarland' },
  { value: 'SN', label: 'Sachsen' },
  { value: 'ST', label: 'Sachsen-Anhalt' },
  { value: 'SH', label: 'Schleswig-Holstein' },
  { value: 'TH', label: 'Thüringen' },
] as const

// ---- Profil-Status ----
export const PROFIL_STATUS = [
  { value: 'neu', label: 'Neu', color: '#3B82F6' },
  { value: 'geprueft', label: 'Geprüft', color: '#8B5CF6' },
  { value: 'matchbar', label: 'Matchbar', color: '#10B981' },
  { value: 'in_vermittlung', label: 'In Vermittlung', color: '#F59E0B' },
  { value: 'vorgestellt', label: 'Vorgestellt', color: '#EC4899' },
  { value: 'interview', label: 'Interview', color: '#6366F1' },
  { value: 'platziert', label: 'Platziert', color: '#059669' },
  { value: 'abgesagt', label: 'Abgesagt', color: '#EF4444' },
] as const

// ---- Match-Kategorien ----
export const MATCH_KATEGORIEN = [
  { value: 'sehr_passend', label: 'Sehr passend', color: '#059669', minScore: 75 },
  { value: 'passend', label: 'Passend', color: '#F59E0B', minScore: 50 },
  { value: 'bedingt_passend', label: 'Bedingt passend', color: '#EF4444', minScore: 30 },
] as const

// ---- Pipeline Event-Typen ----
export const PIPELINE_EVENT_TYPEN = [
  { value: 'vorgestellt', label: 'Vorgestellt', icon: '📤' },
  { value: 'kontaktiert', label: 'Kontaktiert', icon: '📞' },
  { value: 'antwort_erhalten', label: 'Antwort erhalten', icon: '📩' },
  { value: 'interview_geplant', label: 'Interview geplant', icon: '📅' },
  { value: 'interview_durchgefuehrt', label: 'Interview durchgeführt', icon: '✅' },
  { value: 'angebot_erhalten', label: 'Angebot erhalten', icon: '📝' },
  { value: 'platziert', label: 'Platziert', icon: '🎉' },
  { value: 'abgesagt_kandidat', label: 'Abgesagt (Kandidat)', icon: '❌' },
  { value: 'abgesagt_arbeitgeber', label: 'Abgesagt (Arbeitgeber)', icon: '🚫' },
] as const

// ---- Einrichtungstypen ----
export const EINRICHTUNGSTYPEN = [
  { value: 'klinik', label: 'Klinik / Krankenhaus' },
  { value: 'pflegeheim', label: 'Pflegeheim (stationär)' },
  { value: 'ambulant', label: 'Ambulanter Dienst' },
  { value: 'intensivpflege', label: 'Außerklinische Intensivpflege' },
  { value: 'reha', label: 'Reha-Einrichtung' },
  { value: 'psychiatrie', label: 'Psychiatrie' },
  { value: 'tagespflege', label: 'Tagespflege' },
  { value: 'betreutes_wohnen', label: 'Betreutes Wohnen' },
  { value: 'sonstiges', label: 'Sonstiges' },
] as const

// ---- Bewertungsskalen ----
export const BEWERTUNG_SKALA = [
  { value: 1, label: 'Sehr schlecht' },
  { value: 2, label: 'Schlecht' },
  { value: 3, label: 'Mittel' },
  { value: 4, label: 'Gut' },
  { value: 5, label: 'Sehr gut' },
] as const

export const JA_NEIN_UNBEKANNT = [
  { value: 'ja', label: 'Ja' },
  { value: 'nein', label: 'Nein' },
  { value: 'unbekannt', label: 'Unbekannt' },
] as const

// ---- Stellen-Quellen ----
export const STELLEN_QUELLEN = [
  { value: 'manuell', label: 'Manuell angelegt' },
  { value: 'import', label: 'Importiert' },
  { value: 'karriereseite', label: 'Karriereseite' },
  { value: 'jobboerse', label: 'Jobbörse' },
] as const

// ---- Stellen-Status ----
export const STELLEN_STATUS = [
  { value: 'aktiv', label: 'Aktiv', color: '#10B981' },
  { value: 'inaktiv', label: 'Inaktiv', color: '#94A3B8' },
  { value: 'archiviert', label: 'Archiviert', color: '#64748B' },
  { value: 'besetzt', label: 'Besetzt', color: '#8B5CF6' },
] as const

// ---- Funnel Steps ----
export const FUNNEL_STEPS = [
  { id: 1, label: 'Grunddaten', icon: '👤', estimate: '~1 Min.' },
  { id: 2, label: 'Berufliches Profil', icon: '📋', estimate: '~1 Min.' },
  { id: 3, label: 'Wechselwünsche', icon: '🎯', estimate: '~2 Min.' },
  { id: 4, label: 'Wechselgründe', icon: '💭', estimate: '~1 Min.' },
  { id: 5, label: 'Prioritäten', icon: '⭐', estimate: '~1 Min.' },
  { id: 6, label: 'Abschluss', icon: '✅', estimate: '~30 Sek.' },
] as const

/* ============================================
   MATCHING v2 — Auswahllisten
   ============================================ */

// ---- Anerkennungsstatus (Pflegekraft) ----
export const ANERKENNUNGSSTATUS = [
  { value: 'deutsche_ausbildung', label: 'Deutsche Ausbildung' },
  { value: 'anerkannt', label: 'Anerkennung abgeschlossen' },
  { value: 'in_anerkennung', label: 'Anerkennung läuft noch' },
  { value: 'nicht_begonnen', label: 'Anerkennung noch nicht begonnen' },
  { value: 'nicht_relevant', label: 'Nicht relevant' },
] as const

// ---- Trägerarten (Arbeitgeber) ----
export const TRAEGERARTEN = [
  { value: 'privat', label: 'Privat' },
  { value: 'freigemeinnuetzig', label: 'Freigemeinnützig' },
  { value: 'oeffentlich', label: 'Öffentlich' },
  { value: 'sonstige', label: 'Sonstige' },
] as const

// ---- Sprachlevel ----
export const SPRACHLEVEL = [
  { value: 'keine', label: 'Keine besondere Anforderung' },
  { value: 'b1', label: 'Mindestens B1' },
  { value: 'b2', label: 'Mindestens B2' },
  { value: 'c1', label: 'Mindestens C1' },
] as const

// ---- Verfügbarkeit (Pflegekraft: Schichten) ----
export const VERFUEGBARKEIT = [
  { value: 'ja', label: 'Ja, möglich' },
  { value: 'optional', label: 'Nur als Option' },
  { value: 'nein', label: 'Nein' },
] as const

// ---- Häufigkeit (Arbeitgeber: Dienste) ----
export const HAEUFIGKEIT_AG = [
  { value: 'ja', label: 'Ja, regelmäßig' },
  { value: 'selten', label: 'Selten' },
  { value: 'nein', label: 'Nein' },
] as const

// ---- Einspringen aus der Freizeit ----
export const EINSPRINGEN_HAEUFIGKEIT = [
  { value: 'haeufig', label: 'Häufig' },
  { value: 'gelegentlich', label: 'Gelegentlich' },
  { value: 'selten', label: 'Selten' },
  { value: 'nie', label: 'So gut wie nie' },
] as const

// ---- Wochenend-Frequenz ----
export const WOCHENEND_FREQUENZ = [
  { value: 'jedes_2', label: 'Jedes 2. Wochenende' },
  { value: 'jedes_3', label: 'Jedes 3. Wochenende' },
  { value: 'jedes_4', label: 'Jedes 4. Wochenende oder seltener' },
  { value: 'individuell', label: 'Individuell regelbar' },
  { value: 'keine', label: 'Keine Wochenenddienste' },
] as const

// ---- Feedback-Rhythmus ----
export const FEEDBACK_RHYTHMUS = [
  { value: 'monatlich', label: 'Monatlich' },
  { value: 'quartalsweise', label: 'Quartalsweise' },
  { value: 'jaehrlich', label: 'Jährlich' },
  { value: 'selten', label: 'Selten / anlassbezogen' },
] as const

// ---- Benefits ----
export const BENEFITS_OPTIONEN = [
  { value: 'betriebliche_av', label: 'Betriebliche Altersvorsorge' },
  { value: 'tarif', label: 'Tarifvertrag (z. B. TVöD)' },
  { value: '13_monatsgehalt', label: '13. Monatsgehalt' },
  { value: 'urlaubsgeld', label: 'Urlaubsgeld' },
  { value: 'extra_urlaub', label: 'Zusätzliche Urlaubstage' },
  { value: 'fortbildungsbudget', label: 'Fortbildungsbudget' },
  { value: 'fortbildungsfrei', label: 'Bezahlte Fortbildungsfreistellung' },
  { value: 'jobticket', label: 'Jobticket / Fahrtkostenzuschuss' },
  { value: 'dienstrad', label: 'Dienstrad / Leasing' },
  { value: 'dienstwagen', label: 'Dienstwagen' },
  { value: 'kinderbetreuung', label: 'Kinderbetreuung' },
  { value: 'praemien', label: 'Prämien / Bonuszahlungen' },
  { value: 'gesundheit', label: 'Gesundheitsangebote' },
  { value: 'wohnung', label: 'Mitarbeiter-Wohnung / Hilfe bei Wohnung' },
  { value: 'verpflegung', label: 'Kostenlose Verpflegung / Kantine' },
  { value: 'rabatte', label: 'Mitarbeiterrabatte' },
  { value: 'flexarbeit', label: 'Flexible Arbeitszeitmodelle' },
  { value: 'sabbatical', label: 'Sabbatical / Auszeit-Modelle' },
  { value: 'events', label: 'Mitarbeiter-Events' },
  { value: 'wellness', label: 'Wellness / Massagen' },
] as const

// ---- Zuschläge-Stufen (Arbeitgeber-Selbsteinschätzung) ----
export const ZUSCHLAEGE_STUFEN = [
  { value: 'keine', label: 'Keine besonderen Zuschläge' },
  { value: 'tarif', label: 'Tarif-/Branchenüblich' },
  { value: 'ueber_tarif', label: 'Etwas über Branche' },
  { value: 'deutlich_drueber', label: 'Deutlich über Branche' },
  { value: 'top', label: 'Besonders attraktiv' },
] as const

// ---- Match-Kategorien v2 ----
export const MATCH_KATEGORIEN_V2 = [
  { value: 'sehr_stark', label: 'Sehr starker Match', color: '#059669', icon: '🏆' },
  { value: 'gut', label: 'Guter Match', color: '#10B981', icon: '👍' },
  { value: 'solide', label: 'Solider Match', color: '#3B82F6', icon: '✅' },
  { value: 'mit_risiken', label: 'Match mit Risiken', color: '#F59E0B', icon: '⚠️' },
  { value: 'schwach', label: 'Schwacher Match', color: '#F97316', icon: '🤔' },
  { value: 'nicht_empfehlenswert', label: 'Nicht empfehlenswert', color: '#94A3B8', icon: '👎' },
  { value: 'knockout', label: 'Knock-out', color: '#EF4444', icon: '❌' },
] as const
